export enum EventLocation {
    DesjardinsPollack = 0,
    OnCampus = 1,
    OffCampus = 2
}